var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('LoaderReport') : _c('router-view', {
    key: _vm.$route.fullPath
  }), _vm.isLanguageDialog ? _c('language-dialog', {
    on: {
      "next": function next($event) {
        _vm.isLanguageDialog = false;
      }
    },
    model: {
      value: _vm.isLanguageDialog,
      callback: function callback($$v) {
        _vm.isLanguageDialog = $$v;
      },
      expression: "isLanguageDialog"
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }